import { ROUTES } from '@/config/routes';
import { usePrivyAccount } from '@/hooks';
import { Navigate, Outlet } from 'react-router-dom';
import { PageSkeleton } from '../ui';
import useFundedAccount from '@/hooks/use-funded-account';

export default function DepositLayout() {
  const { isFundedOrEval } = useFundedAccount();
  const { isConnected, isEmbedded, isReady } = usePrivyAccount();
  if (!isReady) return <PageSkeleton />;
  if (!isConnected || !isEmbedded || isFundedOrEval)
    return <Navigate to={ROUTES.TRADE} />;
  return <Outlet />;
}
